<template>
    <button 
        class="button button--back-to-top align-items-center d-none d-lg-flex flex-column p-0" 
        name="top" 
        type="button" 
        @click="backToTop()"
    >
        <slot name="icon"></slot>
        <slot name="text"></slot>
    </button>
</template>

<script>
/*
* Back to Top Button
* ---
* Just the button to scroll back to top in the footer, I had to do it 
* via a vue component otherwise it didn't seem to connect properly to the method :'(
*/

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

export default {
    methods: {
        backToTop() {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        }
    }
}
</script>